(function aemNavigation() {
  function navigationInit(element) {
    // Create a NodeList object for all the navigation buttons that open the subnav
    const navButtonClose = element.querySelector(".national-nav .btn-close");
    const navModalJquery = $("#nationalExpandedNav");
    const navPrimary = element.querySelector(".navigation-primary");
    const firstLevelNavItem = element.querySelectorAll(".first-level-item");
    const subNavMenuOuter = element.querySelectorAll(".subnav-menu-outer");

    /* 	This creates the reverse hover effect by adding a .hover class to
     *	navPrimary, then lets CSS handle the rest */
    firstLevelNavItem.forEach((el) => {
      el.addEventListener("mouseover", function () {
        navPrimary.classList.add("hover");
      });
      el.addEventListener("mouseout", function () {
        navPrimary.classList.remove("hover");
      });
    });

    /*	This removes stops the hover event from bubbling and removes .hover
     *	applied above when a child element is hovered over. This is because the
     *	second panel items are a child of the first panel and we only want the
     *	reverse hover effect when hovering over the first panel (.navPrimary) */
    subNavMenuOuter.forEach((el) => {
      el.addEventListener("mouseover", function (e) {
        e.stopPropagation();
        navPrimary.classList.remove("hover");
      });
      el.addEventListener("mouseout", function () {
        navPrimary.classList.add("hover");
      });
    });

    function closeModalOnBackdropClick() {
      const modalBackdrop = document.querySelector(".modal-backdrop");
      $(modalBackdrop).on("click", function () {
        navModalJquery.modal("hide");
      });
    }

    function closeModalOnCloseButtonDesktopClick() {
      navButtonClose.addEventListener("click", function () {
        navModalJquery.modal("hide");
      });
    }

    // Event Listeners
    navModalJquery.on("shown.bs.modal", function (e) {
      navButtonClose.style.display = "block";
      closeModalOnBackdropClick();
      closeModalOnCloseButtonDesktopClick();
      /*  This is used to remove 'padding-right: 15px' that BS4 adds
          after the 'show' event for the modal. This forced padding
          was causing spacing issues on the right of the nav, so it
          was removed via JS rather than applying styles to the body */
      document.body.style.removeProperty("padding-right");
    });

    navModalJquery.on("hide.bs.modal", function (e) {
      navButtonClose.style.display = "none";
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll('[data-lt-aem="national-nav"]')
      .forEach((element) => {
        navigationInit(element);
      });
  });
})();
